module.exports = __webpack_public_path__ + "img/care.5baea15a.jpg";